import CookieMangement from "./CookieMangement";
import Mustache from "mustache";
require('slick-carousel');


class Landings {

    static instance;

    constructor() {

        if (!Landings.instance) {
            Landings.instance = this;

         this.loadMoreBtn = $('#loadMoreBtn');
         this.ratingsContainer = $('#game-ratings');
         this.limit = 5; // Set the initial limit
         this.offset = 0; // Set the initial offset

        }
        return Landings.instance;
    }

    init() {
        var cookies = new CookieMangement();
        cookies.bindEvents();
        var priceObject = {
            1: 34,
            2: 34,
            3: 51,
            4: 68,
            5: 85,
            6: 102,
            7: 119,
            8: 134,
            9: 150,
            10: 165
        };
        $("#player-slider").on("input", function() {
            var players = $(this).val();
            $(".player-count").text(players+" Spieler");
            var firstPrice = (19.99 / players).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            var secondPrice = (priceObject[players] / players).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            $(".first-price").text(firstPrice);
            $(".second-price").text(secondPrice);
        });

        let animationMenu = lottie.loadAnimation({
            container: document.getElementById('loader-el'),
            renderer: 'svg',
            loop: true,
            autoplay: false,
            path: "/assets/video/loading.json"
        });

        animationMenu.play();

        if ($(".screens-slider").length > 0){


            $(".screens-slider").slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                arrows: false,
                fade: true,
                autoplay: true,
                autoplaySpeed: 2000,
                asNavFor: '.slider-nav'
            });
            $('.slider-nav').slick({
                slidesToShow: 3,
                lazyLoad: 'ondemand',
                slidesToScroll: 1,
                asNavFor: '.screens-slider',
                dots: true,
                centerMode: true,
                focusOnSelect: true
            });
        }

        $('#newsletterForm').submit(function (e) {
            e.preventDefault();

            var email = $('[name="email"]').val();
            var loader = $("#loader-el");

            loader.fadeIn();

            $.ajax({
                url: '/api/newsletter/signup',
                type: 'POST',
                dataType: 'json',
                data: {
                    email: email
                },
                success: function (response) {
                    loader.fadeOut();
                    $('#responseMessage').fadeIn().removeClass('error').addClass('success').text(response.message);
                    $('#newsletterForm')[0].reset();
                },
                error: function (xhr, status, error) {
                    loader.fadeOut();
                    var errorMessage = xhr.status + ': ' + xhr.statusText;
                    $('#responseMessage').fadeIn().removeClass('success').addClass('error').text('Error - ' + errorMessage);
                }
            });
        });

        $(document).on("click", ".play-button, .play-trailer, .play-video", (e) => {
            e.preventDefault();

            var trailerSrc = $(e.currentTarget).data("src");

            $(".trailer-popup").fadeIn();
            $(".trailer-wrapper").html('<div>Um das Video anzuzeigen wird ein externer Player von YouTube.com geladen. Klicke auf den Button um den Player zu laden.</div><a class="load-trailer" data-src="'+trailerSrc+'" href="">Video laden</a>');

        });

        $(document).on("click", ".mobile-nav-trigger", (e) => {
            e.preventDefault();
            $(".mobile-nav").addClass("active");
        });
        $(document).on("click", ".close-promo", (e) => {
            e.preventDefault();
            $(".promo-action").fadeOut(1000);
            cookies.createCookie('promoNewsletterClosed', true, 365);

        });
        $(document).on("click", ".close-mobile-nav", (e) => {
            e.preventDefault();
            $(".mobile-nav").removeClass("active");
        });

        $(document).on("click", ".load-trailer", (e) => {
            e.preventDefault();
            var trailerSrc = $(e.currentTarget).data("src");
            $(".trailer-wrapper").html('<iframe src="' + trailerSrc + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>\n');
        });


        $(document).on("click", ".js-scroll-to-ratings", (e) => {
            e.preventDefault();
            var target = $(".ratings-anchor");

            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 150
                }, 500);
            }

        });

        $(document).on("click", ".trailer-popup", (e) => {
            e.preventDefault();

            if (!$(e.target).is('.load-trailer')) {
                $(".trailer-wrapper").html('');
                $(".trailer-popup").fadeOut();
            }
        });


        $('.question').click(function () {
            $(this).next('.answer').slideToggle();
            $(this).find('i').toggleClass('fa-plus fa-minus');
        });

        const el = document.querySelector(".game-meta");

        if (el) {
            window.addEventListener("scroll", () => {
                const { top } = el.getBoundingClientRect();
                // pinnen, sobald die Oberkante <= 0 ist
                el.classList.toggle("is-pinned", top <= 0);
            });
        }




        if ($("#game-ratings").length > 0){
           this.initRatings();
       }

       if ($(".dummy-viewer").length > 0){
           this.initDummyViewers();
       }
    }


    initDummyViewers(){
        var viewerCount = Math.floor(Math.random() * (102 - 80 + 1)) + 80;
        $('.dummy-viewer').text(viewerCount);

        function updateViewerCount() {
            // Random increment/decrement between 2 and 6
            var change = Math.floor(Math.random() * 5) + 2;

            // Randomly decide whether to add or subtract the change
            viewerCount += Math.random() < 0.5 ? change : -change;

            // Ensure the count stays within the 80-102 range
            viewerCount = Math.max(80, Math.min(102, viewerCount));

            // Update the display
            $('.dummy-viewer').text(viewerCount);

            // Random interval around 2 seconds (plus/minus 200ms)
            var randomInterval = Math.floor(Math.random() * 4000) + 1800;

            // Call updateViewerCount again after randomInterval
            setTimeout(updateViewerCount, randomInterval);
        }

        // Start the simulation
        setTimeout(updateViewerCount, 2000);
    }

    initRatings(){
        var self = this;

        this.loadRatings();

        this.loadMoreBtn.click(function (e) {
            e.preventDefault();
            // Increment the offset on each Load More click
            self.offset += self.limit;
            self.loadRatings();

        });
    }

    loadRatings(){

        // Make an AJAX request to your Laravel API route
        $.ajax({
            url: `/api/game-ratings?limit=${this.limit}&game_id=${$(".ratings").attr("data-game")}&offset=${this.offset}`,
            method: 'GET',
            success: function (data) {
                // Check if there are more ratings
                if (data.length > 0) {
                    // Use Mustache.js to render the new ratings

                    fetch('/templates/ratings.html')
                        .then(response => response.text())
                        .then(template => {

                            // Insert the rendered template into the page
                            const renderedRatings = Mustache.render(template, { ratings: data });
                            // Append the new ratings to the container
                            $('#game-ratings').append(renderedRatings);
                        });


                } else {
                    // No more ratings, hide the Load More button
                    $('#loadMoreBtn').hide();
                }
            },
            error: function (error) {
                console.error('Error fetching ratings:', error);
            }
        });
    }
}

export default Landings;

